import React from "react";
export const BuildColumnFormatter = ({ title, data, columns, rowsPerColumn }) => {
  return (
    <div>
      <span style={{ fontWeight: 600 }}>{title}</span>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gridTemplateRows: `repeat(${rowsPerColumn}, auto)`,
          gridAutoFlow: "column",
          fontSize: "14px",
        }}
      >
        {data.map((item, index) => (
          <div
            key={index}
            //   style={{
            //     display: "grid",
            //     gridTemplateColumns: "30px auto",
            //     alignItems: "start",
            //   }}
          >
            <span>{item.key}</span>
            <span>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/HighBall/GradeCrossingAccidentReport/titleFormatter.jsx